<template>
  <div>
    <div v-if="!userAgent">
      <div class="banner">
        <img :src="image" alt />
      </div>
      <div class="a-container">
        <div class="a-title" >
          <el-tabs v-model="activeName" @tab-click="tabClick">
            <template v-for="(item,index) in content">
              <el-tab-pane :label="item.category_name" :key='index'>
                <div v-html="item.content"></div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div v-else>
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <div class="a-container1">
        <div class="a-title1">
          <el-tabs v-model="activeName" @tab-click="tabClick">
            <template v-for="(item,index) in content">
              <el-tab-pane :label="item.category_name" :key='index'>
                <div v-html="item.content"></div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  data() {
    return {
      activeName: "0",
      image: "",
      content:[]
    };
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.a);
        this.activeName = this.$route.query.a;
      },
      deep: true,
    },
  },
  mounted() {
    var that = this;
    that.$http.get("images/about").then(function (res) {//轮播
      that.image = res.data.data.image;
    });
    that.$http.get("about/index_all").then(function (res) {//关于赛捷
      that.content = res.data.data
    });
    this.activeName = this.$route.query.a;
  },
  methods: {
    tabClick: function (tab) {
      let url = "/about?a=" + tab.name;
      this.$root.newVue.$emit("nav_index", url);
      // this.$router.push(url);
    },
  },
};
</script>
<style scoped lang="scss">
.a-container {
  background: #f5f5f5;
}

.banner img {
  width: 100%;
}
// mobile
.banner1 {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height:7rem;
  }
}
</style>
<style lang='scss'>
.a-title .el-tabs__active-bar {
  bottom: -6px;
}
.a-title .el-tabs__item {
  font-size: 18px;
  font-weight: bold;
}
.a-title .el-tabs__nav-scroll, .a-title .el-tab-pane {
    width: 80%;
    margin: 0 auto;
    padding-bottom: 1rem;
}
.a-title1 .el-tab-pane {
  padding-bottom: 1.5rem;
}
.el-tab-pane p {
  font-size: 0.875rem;
}
.el-tab-pane .a-bg img {
  width: 100%;
  height: 80%;
  margin-top: 3%;
}
.el-tab-pane .a-zheng {
  display: grid;
  grid-template-columns: repeat(4, 20%);
  gap: 5rem;
  margin-top: 3%;
}
.el-tab-pane .a-zheng img {
  width: 100%;
}
.a-title1 .el-tabs__nav-scroll {
    padding-bottom: 6px;
    height: 3rem;
    line-height: 3rem;
}
.a-title1 .el-tabs__nav-prev {
    left: 0;
    margin-top: 2.5%;
}
.a-title1 .el-tabs__nav-next {
    right: 0;
    margin-top: 2.5%;
}
.a-title1 .el-tabs__nav-scroll, .a-title1 .el-tab-pane {
    width: 90%;
    margin: 0 auto;
}
.a-title1 .el-tab-pane p{
  font-size: 0.7rem;
}
.a-title1 .a-bg1{
  width:100%;
  height:70%;
  margin-top:1rem;
    img{
      width: 100%;
    }
}
.a-title1 .tit{
  font-size: 0.8rem !important;
  p,span{
    font-size: 0.8rem !important;
    margin-top:1rem;
    line-height: 1.3rem;
  }
}
.a-title1 .el-tabs__item{
  font-weight:bold;
}
.nav .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #43ae82 !important;
    color: #43ae82;
}
</style>